import { useRef } from 'react';
import '../styles/LatestFromDoppler.css';

const POSTS = [
  {
    id: 'introducing-xdp',
    title: 'Introducing XDP',
    date: 'August 26, 2026',
    image: '/images/blog/introducing-xdp.png',
    url: 'https://blog.doppler.finance/blog/introducing-xdp',
  },
  {
    id: 'xrp-seoul',
    title: 'Doppler Finance Joins XRP Seoul 2026 as Platinum Sponsor',
    date: 'August 14, 2026',
    image: '/images/blog/xrp-seoul-2026.png',
    url: 'https://blog.doppler.finance/blog/doppler-finance-joins-xrp-seoul-2026-as-platinum-sponsor',
  },
  {
    id: 'expands-to-base',
    title: 'Doppler Finance Expands to Base, Bringing Infrastructure for cbXRP and Tokenized Assets',
    date: 'July 29, 2026',
    image: '/images/blog/expands-to-base.png',
    url: 'https://blog.doppler.finance/blog/doppler-finance-expands-to-base-bringing-infrastructure-for-cbxrp-and-tokenized-assets',
  },
  {
    id: 'xdp-genesis-airdrop',
    title: '$XDP Genesis Airdrop Registration',
    date: 'July 20, 2026',
    image: '/images/blog/xdp-genesis-airdrop.png',
    url: 'https://blog.doppler.finance/blog/xdp-genesis-airdrop-registration',
  },
  {
    id: 'next-step',
    title: 'The Next Step of Doppler: Building Decentralized Infrastructure',
    date: 'July 16, 2026',
    image: '/images/blog/next-step-decentralized.png',
    url: 'https://blog.doppler.finance/blog/the-next-step-of-doppler-building-decentralized-infrastructure',
  },
  {
    id: 'sbi-partnership',
    title: 'Doppler Finance and SBI Digital Finance Announce Strategic Partnership to Expand Institutional...',
    date: 'July 13, 2026',
    image: '/images/blog/sbi-partnership.png',
    url: 'https://blog.doppler.finance/blog/doppler-finance-and-sbi-digital-finance-announce-strategic-partnership-to-expand-institutional-xrp-finance-in-japan',
  },
  {
    id: 'institutional-lending',
    title: 'The Rise of Institutional Lending for Digital Assets',
    date: 'July 9, 2026',
    image: '/images/blog/institutional-lending.png',
    url: 'https://blog.doppler.finance/blog/the-rise-of-institutional-lending-for-digital-assets',
  },
  {
    id: 'infrastructure-standard',
    title: 'The Infrastructure Standard for Tokenized Markets',
    date: 'July 6, 2026',
    image: '/images/blog/infrastructure-standard.png',
    url: 'https://blog.doppler.finance/blog/the-infrastructure-standard-for-tokenized-markets',
  },
];

export default function LatestFromDoppler({ zIndex }) {
  const trackRef = useRef(null);

  function scrollByCard(direction) {
    const track = trackRef.current;
    if (!track) return;
    const card = track.querySelector('.blog-card');
    const step = card ? card.offsetWidth + 24 : 320;
    track.scrollBy({ left: direction * step, behavior: 'smooth' });
  }

  return (
    <section className="latest-doppler" style={{ zIndex }}>
      <div className="latest-doppler__topbar">
        <span className="latest-doppler__brand">Doppler.finance</span>
        <span className="latest-doppler__pill">
          <span className="latest-doppler__pill-brace">{'{'}</span>
          Latest from Doppler
          <span className="latest-doppler__pill-brace">{'}'}</span>
        </span>
      </div>

      <h2 className="latest-doppler__heading">
        <span className="latest-doppler__muted">Latest from</span>
        <span className="latest-doppler__bold">Doppler</span>
      </h2>

      {/* Desktop: horizontal scroll carousel + arrow controls */}
      <div className="latest-doppler__carousel">
        <div className="latest-doppler__track" ref={trackRef}>
          {POSTS.map((post) => (
            <a
              key={post.id}
              href={post.url}
              target="_blank"
              rel="noreferrer"
              className="blog-card"
            >
              <div className="blog-card__image-wrap">
                <img src={post.image} alt={post.title} loading="lazy" />
              </div>
              <div className="blog-card__body">
                <h3 className="blog-card__title">{post.title}</h3>
                <span className="blog-card__date">{post.date}</span>
              </div>
            </a>
          ))}
        </div>
        <div className="latest-doppler__arrows">
          <button type="button" aria-label="Previous" onClick={() => scrollByCard(-1)}>←</button>
          <button type="button" aria-label="Next" onClick={() => scrollByCard(1)}>→</button>
        </div>
      </div>

      {/* Mobile: stacked full-width list */}
      <div className="latest-doppler__list">
        {POSTS.map((post) => (
          <a
            key={post.id}
            href={post.url}
            target="_blank"
            rel="noreferrer"
            className="blog-card blog-card--mobile"
          >
            <div className="blog-card__image-wrap">
              <img src={post.image} alt={post.title} loading="lazy" />
            </div>
            <div className="blog-card__body">
              <h3 className="blog-card__title">{post.title}</h3>
              <span className="blog-card__date">{post.date}</span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}